<div
  [ngSwitch]="fieldType"
  [bfxTooltip]="errorMsg"
  tooltipPosition="top"
  tooltipStyleClass="interface-control__spinner__tooltip"
  class="custom-field-instance"
  [tooltipDisabled]="!hasError || inputFocused"
>
  <ng-container *ngSwitchCase="ATDLNControlType.DROPDOWN_LIST">
    <bfx-autoComplete
      #autocomplete
      [alternateConfig]="autocompleteConfig"
      [disabled]="isDisabled"
      [label]="displayName"
      [(ngModel)]="value"
      [suggestions]="domainSuggestions"
      (completeMethod)="searchDomain($event)"
      (onSelect)="onSelectDomain($event)"
      (onFocus)="onInputFocus()"
      (onBlur)="onInputBlur()"
      [dropdown]="true"
      appendTo="body"
      nativeDesktopDropdown="customFields"
      target="customFields"
      autoHighlight="true"
      delay="4"
      field="label"
      dataKey="label"
      [minLength]="0"
      [maxLength]="maxLength"
      [state]="state"
      placeholder="Custom Value"
      [size]="'sm'"
    >
    </bfx-autoComplete>
  </ng-container>

  <ng-container *ngSwitchCase="ATDLNControlType.TEXTFIELD" class="custom-field-instance">
    <bfx-text-input
      class="custom-text-field"
      [inputLabelText]="displayName"
      type="search"
      autocomplete="off"
      [(ngModel)]="value"
      [disabled]="isDisabled"
      [size]="'sm'"
      [required]="false"
      [minLength]="0"
      [maxLength]="maxLength"
      tabindex="-1"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
      [externalState]="state"
    ></bfx-text-input>
  </ng-container>
</div>
